import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";

export class ReelFrame {
    private anim: Spine;

    constructor(skel: string, atlas: string) {
        this.init(skel, atlas);
    }

     private init(skel: string, atlas: string): void {
        this.anim = Spine.from({
            skeleton: skel,
            atlas: atlas
        });
        this.anim.label = "reelFrame";
        this.anim.state.setAnimation(0, "5x3", false);
    }

    public getAnim() {
        return this.anim;
    }

    public upgrade(rowsCount : number, callback: () => void) {
        const timescale = isSuperQuickBtnOnGlobal ? 2 : 1;
        this.anim.state.timeScale = timescale;
        sound.play(SoundConstants.REEL_EXTAND, { volume: 1 });
        this.anim.state.setAnimation(0, "5x" + rowsCount, false);
        this.anim.state.addAnimation(0, "5x" + rowsCount + "_loop", false);
        this.anim.state.addListener({
            complete: (entry) => {
                if (entry.animation.name === "5x" + rowsCount) {
                    this.anim.state.clearListeners();
                    this.anim.state.timeScale = 1;
                    callback?.();
                }
            }
        });
    }

    public destroy() {
       // this.anim.destroy();
    }
}
